import React, { useState, useContext } from "react";
import style from "./AddRealizacjaProcesu.module.css";
import iconX from "assets/x.svg";
import Zapisz from "./Zapisz";
import { reg_int } from "utils/initialvalue";
export default function AddRealizacjaProcesu({ setShow, show, wykonanie,value, setValue,grup }) {
  const [isBrak, setIsBrak] = useState(false);

  if (show) {
    return (
      <div className={style.grayScaleBackground}>
        <div
          onDoubleClick={() => {
            // console.clear();
            // console.log("daneKlienta : ");
          }}
          className={style.window}
        >
          <Header setShow={setShow}></Header>
          <div className={style.center}>

                      <div className={style.columnContainer}>
                            <Naklad  value={value} setValue={setValue} wykonanie={wykonanie}/>

                <div className={style.checkboxWrapper}>
                  <input
                    type="checkbox"
                    id="isBrakCheckbox"
                    className={style.checkboxInput}
                    checked={isBrak}
                    onChange={(e) => setIsBrak(e.target.checked)}
                  />
                  <label htmlFor="isBrakCheckbox" className={style.checkboxLabel}>
                    Dodaj jako brak
                  </label>
                </div>
          </div>
          </div>
          <div className={style.footer}>
            <Zapisz setShow={setShow} wykonanie={wykonanie} value={value}  grup={grup} isBrak={isBrak}/>
          </div>
        </div>
      </div>
    );
  }
}

function Header({ setShow }) {
  return (
    <div className={style.header}>
      <p className={style.title}>Dodaj realizację </p>
      <Zamknij setShow={setShow} />
    </div>
  );
}
function Zamknij({ setShow }) {
  return (
    <img
      className={style.zamknij_icon}
      src={iconX}
      onClick={() => {
        setShow(false);
      }}
      alt="Procesy"
    />
  );
}

function Naklad({ value,setValue,wykonanie }) {
  return (
    <div className={style.labelinput}>
      <label className={style.label}> Zostało : {wykonanie.do_wykonania || wykonanie.naklad} </label>
      <input
        className={style.firma}
        type="text"
        value={value}
        onChange={(event) => {
            // const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻ./-]+$/;
if ( event.target.value === '' || reg_int.test(event.target.value)) {

  setValue(event.target.value)
}
          
          }}
      ></input>
    </div>
  );
}
